import { REGISTER_FORM_HOOKS, RELEASE_FORM_HOOKS } from '../actions';

const formHooksReducer = (state = null, { type, payload }) => {
    if (type === REGISTER_FORM_HOOKS) {
        return { ...payload };
    }

    if (type === RELEASE_FORM_HOOKS) {
        return null;
    }

    return state;
};

export default formHooksReducer;
